'use strict';

var styled = require('styled-components');

const commonStyles = styled.css `
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  font-family: ${({ theme }) => theme.designTokens.tabFontFamily};
  font-weight: ${({ theme }) => theme.designTokens.tabFontWeight};
  font-size: ${({ theme }) => theme.designTokens.tabFontSize};
  line-height: ${({ theme }) => theme.designTokens.tabLineHeight};
  letter-spacing: ${({ theme }) => theme.designTokens.tabLetterSpacing};
  padding: ${({ theme }) => theme.designTokens.tabPaddingY} ${({ theme }) => theme.designTokens.tabPaddingX};

  &,
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;
const defaultStyles = {
    normal: styled.css `
    ${commonStyles}
    color: ${({ theme }) => theme.designTokens.tabDefaultTextColor};
    &:hover {
      color: ${({ theme }) => theme.designTokens.tabDefaultHoverTextColor};
      box-shadow: ${({ theme }) => theme.designTokens.tabDefaultHoverBoxShadow};
    }
    &:focus {
      color: ${({ theme }) => theme.designTokens.tabDefaultFocusTextColor};
      box-shadow: ${({ theme }) => theme.designTokens.tabDefaultFocusBoxShadow};
    }
  `,
    active: styled.css `
    color: ${({ theme }) => theme.designTokens.tabDefaultActiveTextColor};
    box-shadow: ${({ theme }) => theme.designTokens.tabDefaultActiveBoxShadow};
  `,
};
const datatableStyles = {
    normal: styled.css `
    ${commonStyles}
    color: ${({ theme }) => theme.designTokens.tabDatatableTextColor};
    background: ${({ theme }) => theme.designTokens.tabDatatableBackgroundColor};
    border-radius: ${({ theme }) => theme.designTokens.tabDatatableBorderRadius};
    &:hover {
      color: ${({ theme }) => theme.designTokens.tabDatatableHoverTextColor};
      background: ${({ theme }) => theme.designTokens.tabDatatableHoverBackgroundColor};
    }
    &:focus {
      color: ${({ theme }) => theme.designTokens.tabDatatableFocusTextColor};
      background: ${({ theme }) => theme.designTokens.tabDatatableFocusBackgroundColor};
    }
  `,
    active: styled.css `
    color: ${({ theme }) => theme.designTokens.tabDatatableActiveTextColor};
    background: ${({ theme }) => theme.designTokens.tabDatatableActiveBackgroundColor};
  `,
};
const tabStylesByVariant = {
    default: defaultStyles,
    datatable: datatableStyles,
};

exports.tabStylesByVariant = tabStylesByVariant;
//# sourceMappingURL=Tab.styles.js.map
